<div class="divContainer">
  <br />
  <div id="divitemList" style="overflow:hidden;overflow-y:auto;">
  </div>

  <button type="button" id="btnPopupDT" class="btn btn-block btn-primary float-sm-right" (click)="show()" style="display:none">POP-UP</button>

  <app-articlemeta></app-articlemeta>

</div>
